var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAcademyIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5514 1.94225C11.8352 1.80591 12.1648 1.80591 12.4486 1.94225L23.4051 7.20541C23.7685 7.37996 24 7.74978 24 8.15579C24 8.56179 23.7685 8.93161 23.4051 9.10617L12.4486 14.3693C12.1648 14.5057 11.8352 14.5057 11.5514 14.3693L0.594852 9.10617C0.23147 8.93161 0 8.56179 0 8.15579C0 7.74978 0.23147 7.37996 0.594852 7.20541L11.5514 1.94225ZM3.47055 8.15579L12 12.2531L20.5295 8.15579L12 4.05851L3.47055 8.15579Z",
    fill: "#6C74B4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.26087 16.956V10.7874H4.17391V17.6295C4.17391 18.0401 4.41056 18.4132 4.78011 18.5852L11.5627 21.7431C11.8402 21.8723 12.1598 21.8723 12.4373 21.7431L19.2199 18.5852C19.5894 18.4132 19.8261 18.0401 19.8261 17.6295V10.7874H17.7391V16.956L12 19.628L6.26087 16.956Z",
    fill: "#6C74B4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9565 7.10315C23.5328 7.10315 24 7.57443 24 8.15579V14.4716C24 15.0529 23.5328 15.5242 22.9565 15.5242C22.3802 15.5242 21.913 15.0529 21.913 14.4716V8.15579C21.913 7.57443 22.3802 7.10315 22.9565 7.10315Z",
    fill: "#6C74B4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcademyIcon);
export default __webpack_public_path__ + "static/media/academy-icon.0e93b5378c2ba24ec7d7dbe8845bca6c.svg";
export { ForwardRef as ReactComponent };